import { create_ssr_component, add_attribute } from "svelte/internal";
import { onMount } from "svelte";
import { r as resolve_wasm_src } from "./DownloadLink.js";
const Canvas3D = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let url;
  let BABYLON_VIEWER;
  let { value } = $$props;
  let { display_mode } = $$props;
  let { clear_color } = $$props;
  let { camera_position } = $$props;
  let { zoom_speed } = $$props;
  let { pan_speed } = $$props;
  let { resolved_url = void 0 } = $$props;
  let latest_url;
  let canvas;
  let viewer;
  let viewerDetails;
  let mounted = false;
  onMount(() => {
    const initViewer = async () => {
      BABYLON_VIEWER = await import("./index17.js").then((n) => n.bY);
      BABYLON_VIEWER.createViewerForCanvas(canvas, {
        clearColor: clear_color,
        useRightHandedSystem: true,
        animationAutoPlay: true,
        cameraAutoOrbit: { enabled: false },
        onInitialized: (details) => {
          viewerDetails = details;
        }
      }).then((promiseViewer) => {
        viewer = promiseViewer;
        mounted = true;
      });
    };
    initViewer();
    return () => {
      viewer?.dispose();
    };
  });
  function setRenderingMode(pointsCloud, wireframe) {
    viewerDetails.scene.forcePointsCloud = pointsCloud;
    viewerDetails.scene.forceWireframe = wireframe;
  }
  function load_model(url2) {
    if (viewer) {
      if (url2) {
        viewer.loadModel(url2, {
          pluginOptions: { obj: { importVertexColors: true } }
        }).then(() => {
          if (display_mode === "point_cloud") {
            setRenderingMode(true, false);
          } else if (display_mode === "wireframe") {
            setRenderingMode(false, true);
          } else {
            update_camera(camera_position, zoom_speed, pan_speed);
          }
        });
      } else {
        viewer.resetModel();
      }
    }
  }
  function update_camera(camera_position2, zoom_speed2, pan_speed2) {
    const camera = viewerDetails.camera;
    if (camera_position2[0] !== null) {
      camera.alpha = camera_position2[0] * Math.PI / 180;
    }
    if (camera_position2[1] !== null) {
      camera.beta = camera_position2[1] * Math.PI / 180;
    }
    if (camera_position2[2] !== null) {
      camera.radius = camera_position2[2];
    }
    camera.lowerRadiusLimit = 0.1;
    const updateCameraSensibility = () => {
      camera.wheelPrecision = 250 / (camera.radius * zoom_speed2);
      camera.panningSensibility = 1e4 * pan_speed2 / camera.radius;
    };
    updateCameraSensibility();
    camera.onAfterCheckInputsObservable.add(updateCameraSensibility);
  }
  function reset_camera_position() {
    if (viewerDetails) {
      viewer.resetCamera();
    }
  }
  if ($$props.value === void 0 && $$bindings.value && value !== void 0)
    $$bindings.value(value);
  if ($$props.display_mode === void 0 && $$bindings.display_mode && display_mode !== void 0)
    $$bindings.display_mode(display_mode);
  if ($$props.clear_color === void 0 && $$bindings.clear_color && clear_color !== void 0)
    $$bindings.clear_color(clear_color);
  if ($$props.camera_position === void 0 && $$bindings.camera_position && camera_position !== void 0)
    $$bindings.camera_position(camera_position);
  if ($$props.zoom_speed === void 0 && $$bindings.zoom_speed && zoom_speed !== void 0)
    $$bindings.zoom_speed(zoom_speed);
  if ($$props.pan_speed === void 0 && $$bindings.pan_speed && pan_speed !== void 0)
    $$bindings.pan_speed(pan_speed);
  if ($$props.resolved_url === void 0 && $$bindings.resolved_url && resolved_url !== void 0)
    $$bindings.resolved_url(resolved_url);
  if ($$props.update_camera === void 0 && $$bindings.update_camera && update_camera !== void 0)
    $$bindings.update_camera(update_camera);
  if ($$props.reset_camera_position === void 0 && $$bindings.reset_camera_position && reset_camera_position !== void 0)
    $$bindings.reset_camera_position(reset_camera_position);
  url = value.url;
  {
    {
      resolved_url = url;
      if (url) {
        latest_url = url;
        const resolving_url = url;
        resolve_wasm_src(url).then((resolved) => {
          if (latest_url === resolving_url) {
            resolved_url = resolved ?? void 0;
          } else {
            resolved && URL.revokeObjectURL(resolved);
          }
        });
      }
    }
  }
  mounted && load_model(resolved_url);
  return `<canvas${add_attribute("this", canvas, 0)}></canvas>`;
});
export {
  Canvas3D as default
};
